<template>
    <div ref="vizitOne" class="vizit-one" @focusin="onFocus" @focusout="onFocusOut">
        <button ref="catcherFocus" class="vizit-one__catcherFocus" />
        <div class="vizit-one__title h5">{{ urlTitle }}</div>
        <div class="vizit-one__url h5">{{ visitLink }}</div>
        <div class="vizit-one__delimiter"><span>{{ or }}</span></div>
        <div class="vizit-one__title h5">{{ qrTitle }}</div>
        <qrcode-vue v-if="url" class="qr-code-medium vizit-one__img" :value="url" :level="'H'" render-as="svg" />
    </div>
</template>

<script setup lang="ts">
    import { computed, type Ref, ref } from 'vue';
    import { Strings } from "@/locales/types/enums/strings";
    import QrcodeVue from 'qrcode.vue';
    import { useCleanUrl } from "@/composables/useCleanUrl";
    import { useI18n } from "vue-i18n";
    import type { ExposeInterface } from "./types";

    const { t } = useI18n();
    const props = defineProps<{
        url: string | null;
    }>();
    const emit = defineEmits(['focusin', 'focusout']);

    const visitLink = computed((): string => useCleanUrl(props.url));
    const urlTitle: string = t(Strings.VIZIT_ONE_URL_TITLE).toString();
    const or: string = t(Strings.VIZIT_ONE_URL_OR).toString();
    const qrTitle: string = t(Strings.VIZIT_ONE_URL_QR_TITLE).toString();
    const catcherFocus: Ref<HTMLButtonElement | null> = ref(null);

    const focusToCatcher = () => {
        if (catcherFocus.value) {
            catcherFocus.value.focus();
        }
    };
    const onFocus = () => {
        emit('focusin');
    };
    const onFocusOut = () => {
        emit('focusout');
    };

    defineExpose<ExposeInterface>({
        focusToCatcher
    });

</script>

<style lang="scss">
    @import url("styles.scss");
</style>
